import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';

export class SliderButtonStyle extends GlobalButtonStyle {
  marginTop = 'uk-margin-top';
  transition = '';

  static normalize(styles: Partial<SliderButtonStyle>): SliderButtonStyle {
    const globalButtonStyle: GlobalButtonStyle = GlobalButtonStyle.normalize(styles);
    const pureStyles = new SliderButtonStyle();

    Object.assign(pureStyles, globalButtonStyle);

    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
